import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import DeliveryInfo from "../components/Home/DeliveryInfo";
import TrendingProducts from "../components/Home/TrendingProducts";
import BestSeller from "../components/Home/BestSeller";
import HomeCategory from "../components/Home/HomeCategory";
import Hero from "../components/Home/Hero";
import PromoBanner from "../components/PromoBanner";
import WhyChooseUs from "../components/Home/WhyChooseUs";
import Newsletter from "../components/Home/Newsletter";
import BrandSlider from "../components/Home/BrandSlider";
import { motion } from "framer-motion";

const Home = () => {
  const [addedItems, setAddedItems] = useState([]);
  const [product, setProduct] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isShopOpen, setIsShopOpen] = useState(true);
  const baseUrl = process.env.REACT_APP_API_URL;

  // --- Check Shop Status ---
  useQuery({
    queryKey: ["shop-status"],
    queryFn: async () => {
      try {
        const res = await axios.get(`${baseUrl}shop`);
        const status = res.data.shopData?.isOpen ?? true;
        setIsShopOpen(status);
        return res.data;
      } catch (error) {
        console.error("Failed to fetch shop status", error);
        return null;
      }
    },
  });

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}productlist`
        );
        const data = await response.json();
        setProduct(data.products || []);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
    fetchProducts();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}categories`
      );
      const data = await response.json();
      setCategories(data);
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    setAddedItems(cart.map((item) => item._id));
  }, []);

  const addToCart = (item) => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    window.dispatchEvent(new Event("cartUpdated"));

    if (!cart.some((cartItem) => cartItem._id === item._id)) {
      cart.push(item);
      localStorage.setItem("cart", JSON.stringify(cart));
      setAddedItems([...addedItems, item._id]);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      style={{ overflowX: "hidden" }}
    >
      <Hero />
      <HomeCategory />

      <div style={{ position: "relative" }}>
        {!isShopOpen && (
          <div
            className="shop-closed-overlay"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(255, 255, 255, 0.6)",
              backdropFilter: "blur(4px)",
              zIndex: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "8px",
            }}
          >
            <div
              className="shop-closed-message p-4 text-center"
              style={{
                background: "#fff",
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                border: "2px solid #d93a38",
                maxWidth: "80%",
              }}
            >
              <h3 style={{ color: "#d93a38", fontWeight: "800", margin: 0 }}>
                SHOP IS CURRENTLY CLOSED
              </h3>
              <p className="mb-0 mt-2 text-muted">
                We are not accepting orders at the moment. Please check back
                later.
              </p>
            </div>
          </div>
        )}
        <div
          style={{
            filter: !isShopOpen ? "blur(5px)" : "none",
            pointerEvents: !isShopOpen ? "none" : "auto",
          }}
        >
          <TrendingProducts
            products={product}
            categories={categories}
            addToCart={addToCart}
            addedItems={addedItems}
          />
        </div>
      </div>

      <PromoBanner />

      <div style={{ position: "relative" }}>
        {!isShopOpen && (
          <div
            className="shop-closed-overlay"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(255, 255, 255, 0.6)",
              backdropFilter: "blur(4px)",
              zIndex: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "8px",
            }}
          >
            <div
              className="shop-closed-message p-4 text-center"
              style={{
                background: "#fff",
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                border: "2px solid #d93a38",
                maxWidth: "80%",
              }}
            >
              <h3 style={{ color: "#d93a38", fontWeight: "800", margin: 0 }}>
                SHOP IS CURRENTLY CLOSED
              </h3>
              <p className="mb-0 mt-2 text-muted">
                We are not accepting orders at the moment. Please check back
                later.
              </p>
            </div>
          </div>
        )}
        <div
          style={{
            filter: !isShopOpen ? "blur(5px)" : "none",
            pointerEvents: !isShopOpen ? "none" : "auto",
          }}
        >
          <BestSeller
            products={product}
            addToCart={addToCart}
            categories={categories}
            addedItems={addedItems}
          />
        </div>
      </div>

      <DeliveryInfo />
    </motion.div>
  );
};

export default Home;
